var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(0.141 0.415)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Profile_Frame_Background_",
    "data-name": "Profile [Frame Background]",
    width: 36,
    height: 37,
    transform: "translate(-0.141 -0.415)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Profile",
    "data-name": "Iconly/Light-Outline/Profile",
    transform: "translate(6.166 3.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-2",
    "data-name": "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M24.066,24.6c0,5.008-6.867,5.586-12.031,5.586h-.37C8.375,30.181,0,29.973,0,24.572c0-4.905,6.591-5.561,11.716-5.586H12.4c3.29.008,11.662.216,11.662,5.617ZM12.034,21.265c-6.474,0-9.755,1.112-9.755,3.308,0,2.215,3.282,3.338,9.755,3.338S21.787,26.8,21.787,24.6c0-2.215-3.28-3.338-9.752-3.338ZM12.034,0a8.067,8.067,0,0,1,0,16.134h-.049A8.067,8.067,0,0,1,12.034,0Zm0,2.17a5.9,5.9,0,0,0-.044,11.8l.044,1.085V13.965a5.9,5.9,0,0,0,0-11.8Z",
    transform: "translate(0 0)",
    fill: "#848484",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.57650699fedec65ae32f28f6d5d800d7.svg";
export { ForwardRef as ReactComponent };